import { todayKolkata } from '../utils/paymentDates';
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const API_BASE = (window.__APP_CONFIG__ && window.__APP_CONFIG__.API_URL) || process.env.REACT_APP_API_URL || '';
if (API_BASE && !axios.defaults.baseURL) {
  axios.defaults.baseURL = API_BASE;
}

const EditEventForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isMounted = useRef(true);

  const [formData, setFormData] = useState({
    name: '',
    startDate: '',
    endDate: '',
    isActive: true,
    eventFee: 0,
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`/api/events/${id}`)
      .then(res => {
        const event = res.data;
        setFormData({
          name: event.name || '',
          startDate: event.startDate ? todayKolkata(new Date(event.startDate)) : '',
          endDate: event.endDate ? todayKolkata(new Date(event.endDate)) : '',
          isActive: event.isActive ?? true,
          eventFee: event.eventFee || 0
        });
        setLoading(false);
      })
      .catch(err => {
        console.error("❌ Error fetching event:", err);
        alert("Error loading event details");
        navigate('/events/list');
      });
    return () => {
      isMounted.current = false;
    };
  }, [id, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (name === 'eventFee' ? parseFloat(value) || 0 : value)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`/api/events/${id}`, formData);
      alert("✅ Event updated successfully");
      if (isMounted.current) {
        navigate('/events/list');
      }
    } catch (err) {
      console.error("❌ Update failed:", err);
      alert("❌ Update failed");
    } finally {
      if (isMounted.current) {
        setSaving(false);
      }
    }
  };

  if (loading) return <p className="text-center py-10">Loading...</p>;

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded shadow">
      <h2 className="text-xl font-semibold mb-4">Edit Event</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Event Name"
          className="border p-2 w-full rounded"
          required
        />

        <input
          type="date"
          name="startDate"
          value={formData.startDate}
          onChange={handleChange}
          className="border p-2 w-full rounded"
          required
        />

        <input
          type="date"
          name="endDate"
          value={formData.endDate}
          onChange={handleChange}
          className="border p-2 w-full rounded"
          required
        />

        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="isActive"
            checked={formData.isActive}
            onChange={handleChange}
            className="mr-2"
          />
          Active
        </label>

        <input
          type="number"
          name="eventFee"
          min="0" step="0.01"
          value={formData.eventFee}
          onChange={handleChange}
          placeholder="Event Fee"
          className="border p-2 w-full rounded"
          required
        />

        <button
          type="submit"
          disabled={saving}
          className={`bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 ${saving ? 'opacity-60 cursor-not-allowed' : ''}`}
        >
          {saving ? 'Updating…' : 'Update Event'}
        </button>
      </form>
    </div>
  );
};

export default EditEventForm;